import styled from "styled-components";

export const Spacer = styled.span`
  flex: 1;
`;
